/* eslint-disable react/jsx-props-no-spreading */
import React from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import { Button } from "@domestika-dev/prudencio/dist/atoms/Buttons";
import { TextForm } from "@domestika-dev/prudencio/dist/atoms/Typography";

export const PublishButton = ({ publishProject, disabled, message, dataLabel }) => {
  return (
    <Button
      size="medium"
      action={publishProject}
      disabled={disabled}
      {...{ "data-label": dataLabel }}
    >
      <TextForm size={["tiny", "tiny", "small"]} fontWeight="medium" color="coco">
        <FormattedMessage id={message} />
      </TextForm>
    </Button>
  );
};

PublishButton.propTypes = {
  publishProject: PropTypes.func,
  disabled: PropTypes.bool,
  message: PropTypes.string,
  dataLabel: PropTypes.string,
};

PublishButton.defaultProps = {
  publishProject: () => {},
  disabled: false,
  message: "",
  dataLabel: "",
};

export default PublishButton;
